import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createPost, updatePost } from "../../actions/postActions";

const PostForm = ({ currentPost }) => {
  const [postData, setPostData] = useState({
    title: "",
    description: "",
    videoURL: "",
  });

  const dispatch = useDispatch();
  const { title, description, videoURL } = postData;

  useEffect(() => {
    if (currentPost) {
      setPostData(currentPost);
    }
  }, [currentPost]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPostData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (currentPost) {
      dispatch(updatePost(postData));
    } else {
      dispatch(createPost(postData));
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>{currentPost ? "Edit Post" : "Create Post"}</h2>
      <label>Title</label>
      <input
        type="text"
        name="title"
        value={title}
        onChange={handleChange}
        required
      />
      <label>Description</label>
      <textarea
        name="description"
        value={description}
        onChange={handleChange}
        required
      />
      <label>Video URL</label>
      <input
        type="text"
        name="videoURL"
        value={videoURL}
        onChange={handleChange}
      />
      <button type="submit">{currentPost ? "Update" : "Submit"}</button>
    </form>
  );
};

export default PostForm;
